class UserModel {
    constructor(data) {
        this.id = data.id;
        this.image = data.profilePicture || "avatar-placeholder";
        this.name = `${data.firstName} ${data.lastName}`;
        this.username = data.email;
        this.date = new Date(data.createdAt).toLocaleDateString();
        this.active = new Date(data.updatedAt).toLocaleDateString();
        this.status = data.status;
        this.permissions = data.permissions?.join(", ") || "No permissions assigned";
    }
}

export default UserModel;
